<template>
  <grocery-available-stores
    :is-grocery-registration="true"
    @valid="handleValidation"
  />
</template>

<script lang="ts" setup>
const emit = defineEmits(['valid']);

import GroceryAvailableStores from '@/components/Main/Operator/Grocery/GroceryAvailableStores.vue';

const handleValidation = (isValid: boolean) => {
  emit('valid', isValid);
};
</script>

<style lang="scss" scoped></style>
